"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScreenPlaceholder = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _dsWeb = require("@olxbr/ds-web");
var _dsSpots = require("@olxbr/ds-spots");
var _style = require("./style");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var ScreenPlaceholder = exports.ScreenPlaceholder = function ScreenPlaceholder(_ref) {
  var spot = _ref.spot,
    title = _ref.title,
    text = _ref.text,
    cta = _ref.cta,
    action = _ref.action;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.Wrapper, {
    children: [spot || /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsSpots.Chat, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.TextWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Text.TitleMedium, {
        children: title
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.TextWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Text.BodyMedium, {
        children: text
      })
    }), !!cta && /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.ButtonWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Button, {
        onClick: action,
        variant: "secondary",
        children: cta
      })
    })]
  });
};
ScreenPlaceholder.propTypes = {
  title: _propTypes.string.isRequired,
  text: _propTypes.string.isRequired,
  cta: _propTypes.string,
  action: _propTypes.func
};